module.exports = __webpack_public_path__ + "assets/edit-white-circle.30802003.svg";